module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightIt.2165c273.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightIt.woff2
// module id = 328
// module chunks = 3